const billReports = {
  description:
    'מספק סקירה כללית של פרטי נסיעה ונוסעים, כולל לוגיסטיקת נסיעות, סטטוסים ומדדים מרכזיים לחיוב וביקורת על שירותי תחבורה.',
  actions: {
    export: 'ייצא',
  },

  table: {
    headers: {
      tripId: 'מזהה נסיעה',
      jobId: 'מזהה הזמנה',
      waitAndReturn: 'המתן וחזור',
      externalId: 'מזהה חיצוני',
      jobStatus: 'סטטוס הזמנה',
      actualPickupTime: 'זמן איסוף בפועל',
      actualDropTime: 'זמן הורדה בפועל',
      plannedPickupTime: 'זמן איסוף מתוכנן',
      plannedDropTime: 'זמן הורדה מתוכנן',
      canceledBy: 'בוטל על ידי',
      assignedBy: 'הוקצה על ידי',
      routeId: 'מזהה מסלול',
      tripStatus: 'סטטוס נסיעה',
      isShared: 'משותף',
      supplier: 'ספק',
      areas: 'אזורים',
      from: 'מ-',
      to: 'אל',
      date: 'תאריך',
      driver: 'נהג',
      vehicle: 'רכב',
      passenger: 'נוסע',
      email: 'אימייל',
      profile: 'פרופיל',
      phone: 'טלפון',
      attributes: 'מאפיין',
      cost: 'עלות',
    },

    cells: {
      reservationStatus: {
        options: {
          new: 'חדש',
          onhold: 'בהמתנה',
          cancelled: 'בוטל',
          routing: 'בהפקה',
          routed: 'נותב',
          picked: 'נאסף',
          dropped: 'הורד',
          noshow: 'לא הופיע',
        },
      },
    },

    filters: {
      assigned: {
        automated: 'מוקצה אוטומטית',
        manually: 'מוקצה ידנית',
        manuallyIntegration: 'צוות ידנית (אינטגרציה)',
        all: 'מוקצה אוטומטית וידנית',
      },
      shared: {
        onlyWithout: 'לא שותף',
        onlyWith: 'משותף',
        all: 'שותף ולא שותף',
      },

      tripStatus: 'כל סטטוסי הנסיעה',
      jobStatus: 'כל סטטוסי ההזמנה',
      vehicles: 'רכבים',
      drivers: 'נהגים',
      suppliers: 'ספקים',
      profiles: 'פרופיל',
      areas: 'אזורים',
      locations: 'תחנות',
      airportLocations: 'מיקומי שדה תעופה',
      attributes: 'מאפיין',
    },
  },
  tableSummary: {
    title: 'דוחות שאטל',
    headers: {
      trips: 'נסיעות',
      jobs: 'הזמנה',
      vehicles: 'רכבים',
      shared: 'משותף',
      autoAssigned: 'צוות אוטומטית',
    },
  },
};

export default billReports;
